import { render, staticRenderFns } from "./FulfillmentProductCatalog.vue?vue&type=template&id=54065bfe"
import script from "./FulfillmentProductCatalog.vue?vue&type=script&lang=js"
export * from "./FulfillmentProductCatalog.vue?vue&type=script&lang=js"
import style0 from "./FulfillmentProductCatalog.vue?vue&type=style&index=0&id=54065bfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports